import ModalExtendedFeedbackFormPresenter from "../components/modal-extended-feedback-form/presenter/modal-extended-feedback-form.js";

const trigger = document.querySelector(`.button_title-product`);

const presenter = new ModalExtendedFeedbackFormPresenter(trigger, false);
presenter.init();
